import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TableDto, ColumnDto } from 'src/app/core/models/generic/table-config.dto';
import { TableComponent } from "../table/table.component";
import { PatientDto } from 'src/app/core/models/patient/patient.dto';
import { PatientContactDto } from 'src/app/core/models/patient/patient-contact.dto';
import { CommonModule, NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { ExtractAgePipe } from "../../../pipes/age.pipe";
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateHelper } from '../../helpers/translate.helper';

@Component({
	selector: 'app-dialog-patient-summary-sheet',
	templateUrl: './dialog-patient-summary-sheet.component.html',
	styleUrls: ['./dialog-patient-summary-sheet.component.scss'],
	standalone: true,
	imports: [
		CommonModule,
		NgIf,
		MatDialogModule,
		MatButtonModule,
		MatIconModule,
		MatDividerModule,
		MatCardModule,
		MatTooltipModule,
		TableComponent,
		ExtractAgePipe
	]
})
export class DialogPatientSummarySheet {
	roomFlag:boolean = true;
	fumFlag:boolean = true;
	colorNameAllergi:string = 'text-primary'; //opciones: 'text-primary' || 'text-caution' || 'text-warning' || 'text-danger' || ''
	classEstructure='col-3'

	patientObj: PatientDto;
	table: TableDto = {} as TableDto;
	flagCard: boolean;
	isSelected: boolean = false;
	listLabels: string[] = [];
	displayedColumns: ColumnDto[];

	selectedIndex: -1;
	msgNoData: "No se encontraron registros";
	urlBase: string;
	readonly URL_MEDICAL_RECORD = "patient/medical-record";

	constructor(public dialogRef: MatDialogRef<DialogPatientSummarySheet>, @Inject(MAT_DIALOG_DATA) public data: any, readonly translateHelper: TranslateHelper){
		dialogRef.disableClose = true;
		this.patientObj = data.patientObj;
		this.urlBase = data.urlBase;
		this.loadDataSource(this.patientObj.contact);
	}

	//Funcion que al seleccionar la fila le coloca la clase para colorear la misma.
	activeTable(objThis):void{
		this.selectedIndex=objThis.id;
	}
	ngOnInit() {
		this.presentationHtml();
	}

	//funcion que ordena los datos medicos para una presentacion visual mejor
	presentationHtml():void {
		if(this.roomFlag==true || this.fumFlag==true)
			this.classEstructure = this.classEstructure === 'col-3' ? 'col-4' : 'col-3';
	}

	loadDataSource(list: PatientContactDto[]){
		this.displayedColumns = [
			{key: 'fullName', label: "Nombre completo"},
			{key: 'contactBirthDateStr', label: "Fecha de nacimiento"},
			{key: 'gender', label: "Sexo"},
			{key: 'relationship', label: "Parentesco"},
			{key: 'contactPhone', label: "Número telefónico"}
		];
		this.table = {
			columns: this.displayedColumns,
			withDeleteAction: false,
			withSelection: false,
			flagBtn: false,
			list:  list,
			update: true,
		}
	}
	redirectTo(){
		this.translateHelper.getFormTranslateByUrl(this.URL_MEDICAL_RECORD, this.urlBase.concat("/", this.URL_MEDICAL_RECORD), true);
		this.dialogRef.close();
	}
}
